import Button from '@components/Button';
import Text from '@components/Text';
import ModalContainer from '@modals/ModalContainer';
import { useFlow } from '@router/stackflow';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

interface Params {
    message: string;
}

const AlertActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { message } = params;
  const { pop } = useFlow();
  return (
        <Modal>
            <ModalContainer>
                <Text>{message}</Text>
                <Button onClick={pop}>닫기</Button>
            </ModalContainer>
        </Modal>
  );
};

export default AlertActivity;
